<script lang="ts">
  import EventCard from '$src/js/modules/events/EventCard.svelte';
  import type { R2REvent } from '$src/types/events';

  const events: R2REvent[] = window.events;

  const approvedEvents = events.filter((event) => event.state === 'approved');
  const pendingEvents = events.filter((event) => event.state === 'pending');
  const rejectedEvents = events.filter((event) => event.state === 'rejected');
</script>

{#if !events.length}
  <div class="2xl:fluid-gap-[16] flex flex-col gap-4">
    <p class="text-16px font-bold">Je hebt nog geen evenementen aangemaakt.</p>
    <a href={window.organizeUrl} class="btn-primary-large"
      >Organiseer een Dikke banden evenement</a
    >
  </div>
{:else}
  <div class="2xl:fluid-gap-[64] flex flex-col gap-16">
    {#if approvedEvents.length}
      <div class="2xl:fluid-gap-[16] flex flex-col gap-4">
        <h2 class="text-28px">Goedgekeurde evenementen</h2>

        {#each approvedEvents as event}
          <EventCard {event} mode="edit" />
        {/each}
      </div>
    {/if}

    {#if pendingEvents.length}
      <div class="2xl:fluid-gap-[16] flex flex-col gap-4">
        <h2 class="text-28px">Evenementen in behandeling</h2>

        {#each pendingEvents as event}
          <EventCard {event} mode="edit" />
        {/each}
      </div>
    {/if}

    {#if rejectedEvents.length}
      <div class="2xl:fluid-gap-[16] flex flex-col gap-4">
        <h2 class="text-28px">Afgewezen evenementen</h2>

        {#each rejectedEvents as event}
          <EventCard {event} mode="edit" />
        {/each}
      </div>
    {/if}
  </div>
{/if}
